// data.js

export const statsData = [
  { id: 1, title: "Total Quotation", value: "95,626", trend: "up", percentage: 12 },
  { id: 2, title: "Approved", value: "626", trend: "up", percentage: 8 },
  { id: 3, title: "Pending", value: "6264", trend: "down", percentage: 5 },
  { id: 4, title: "Rejected", value: "$95,626.14", trend: "up", percentage: 15 },
];

export const chartData = [
  { name: "Jan", total: 65, approved: 40, pending: 25 },
  { name: "Feb", total: 45, approved: 30, pending: 15 },
  { name: "Mar", total: 55, approved: 35, pending: 20 },
  { name: "Apr", total: 35, approved: 25, pending: 10 },
  { name: "May", total: 80, approved: 70, pending: 10 },
  { name: "Jun", total: 95, approved: 85, pending: 10 },
  { name: "Jul", total: 80, approved: 70, pending: 10 },
  { name: "Aug", total: 45, approved: 35, pending: 10 },
  { name: "Sep", total: 85, approved: 75, pending: 10 },
  { name: "Oct", total: 90, approved: 80, pending: 10 },
  { name: "Nov", total: 85, approved: 75, pending: 10 },
  { name: "Dec", total: 80, approved: 70, pending: 10 },
];

export const tableData = [
  {
    id: "#87234",
    company: "Gillette",
    logo: "https://via.placeholder.com/32",
    service: "Tax Planning",
    trade: "Auto Mechanic",
    challenges: "Auto Mechanic",
  },
  {
    id: "#87235",
    company: "Dell",
    logo: "https://via.placeholder.com/32",
    service: "Tax Planning",
    trade: "Auto Mechanic",
    challenges: "Auto Mechanic",
  },
];
